export default __webpack_public_path__ + "static/media/waste-cleansing-footpath.595d6cc1.jpg";